export default __webpack_public_path__ + "static/media/pin.dd103024.svg";